import {
  Role,
  useAssignZoneToUserMutation,
  Zone,
  ZonesForStructureDocument,
} from '@/__generated__/graphql';
import { useAuth0, User } from '@auth0/auth0-react';
import { Button, CircularProgress } from '@mui/material';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useSetAtom } from 'jotai';
import * as state from '@/state';

export const AssignToMeButton = ({
  zoneId,
  handleCloseUsersMenu,
}: {
  zoneId: string;
  handleCloseUsersMenu: () => void;
}) => {
  const { user } = useAuth0();
  const structureId = useGetStructureId();
  const setZones = useSetAtom(state.zones);

  const [mutate, { loading }] = useAssignZoneToUserMutation({
    refetchQueries: [ZonesForStructureDocument],
    onCompleted: () => {
      setZones((prev: User) => {
        return prev.map((zone: Zone) => {
          if (zone.id === zoneId) {
            if (!user) return zone;
            const { sub: id, name, email, picture, roleIds } = user;
            return {
              ...zone,
              workflowStatus: {
                ...zone.workflowStatus!!,
                assignedToUser: { id, name, picture, email, roleIds: roleIds as Role[] },
              },
            };
          }
          return zone;
        });
      });
    },
  });

  const styles = {
    textTransform: 'none',
    fontWeight: 400,
    my: 1,
    width: '100%',
    justifyContent: 'flex-start',
  };

  const assignToMe = async () => {
    await mutate({
      variables: {
        input: {
          zoneIds: [zoneId],
          assigneeId: user?.sub,
          structureId,
        },
      },
    });
    handleCloseUsersMenu();
  };

  return (
    <Button
      sx={{ ...styles, paddingLeft: '10px' }}
      onClick={assignToMe}
      disabled={loading}
      fullWidth
    >
      Assign to me
      {loading && <CircularProgress size={20} sx={{ ml: 1 }} />}
    </Button>
  );
};
